import { render, staticRenderFns } from "./AeqTextBlock.vue?vue&type=template&id=53c13356&"
import script from "./AeqTextBlock.vue?vue&type=script&lang=js&"
export * from "./AeqTextBlock.vue?vue&type=script&lang=js&"
import style0 from "./AeqTextBlock.vue?vue&type=style&index=0&id=53c13356&prod&lang=scss&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports